/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const ParagraphIndentLessIcon = /*#__PURE__*/ createSvgIcon(
  'ParagraphIndentLessIcon',
  {
    ltr: {
      small: ({ id }) => (
        <>
          <g
            clipPath={`url(#${id}_0)`}
            stroke="currentColor"
            strokeMiterlimit={10}
          >
            <path d="M0 .53h16M0 15.5h16M6.7 11.8l9.3-.08M6.7 4.23l9.3.09M6.7 8.01l9.3.01M3.02 5.7L.71 8.01l2.32 2.32M.71 8.01h4.62" />
          </g>
          <defs>
            <clipPath id={`${id}_0`}>
              <path fill="#fff" d="M0 0h16v16H0z" />
            </clipPath>
          </defs>
        </>
      ),
      medium: ({ id }) => (
        <>
          <g
            clipPath={`url(#${id}_0)`}
            stroke="currentColor"
            strokeMiterlimit={10}
          >
            <path d="M0 .52h20M0 19.52h20M8.37 15.77H20M8.37 4.26H20M8.37 8.1H20M8.37 11.93H20M3.6 7.12L.71 10.01l2.89 2.9M.71 10.01h5.77" />
          </g>
          <defs>
            <clipPath id={`${id}_0`}>
              <path fill="#fff" d="M0 0h20v20H0z" />
            </clipPath>
          </defs>
        </>
      ),
      large: ({ id }) => (
        <>
          <g
            clipPath={`url(#${id}_0)`}
            stroke="currentColor"
            strokeMiterlimit={10}
          >
            <path d="M0 .5h24M0 23.5h24M10.05 18.9H24M10.05 5.1H24M10.05 9.7H24M10.05 14.3H24M4.18 8.44L.72 11.91l3.47 3.47M.72 11.91h6.92" />
          </g>
          <defs>
            <clipPath id={`${id}_0`}>
              <path fill="#fff" d="M0 0h24v24H0z" />
            </clipPath>
          </defs>
        </>
      ),
    },
  },
  false
);

export default ParagraphIndentLessIcon;
